import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Tabs,
  Tab,
  Alert,
  Grid,
  CircularProgress,
} from "@mui/material";
import WaterValveControl from "./waterValveControl";
import AlertSettings from "./alertSettings";
import useFeedbackDialog from "../../../../utils/useFeedbackDialogue";
import { useTranslation } from "react-i18next";

const DeviceControlComponent = ({ device }) => {
  const { t } = useTranslation();
  // 检查设备类型是否支持水闸控制
  const showWaterValveControls = device?.seriesAbbr !== "bixu" && device?.seriesAbbr !== undefined;

  const [activeTab, setActiveTab] = useState(
    showWaterValveControls ? "waterValve" : "alertSettings",
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { showSuccess, showError } = useFeedbackDialog();

  // 模拟加载过程
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <Box sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ height: "100%" }}>
      <Card sx={{ boxShadow: 2, borderRadius: 2 }}>
        <CardContent sx={{ p: 6 }}>
          <Typography variant='h4' gutterBottom sx={{ color: "#333", fontWeight: 600 }}>
            {t("device.details_devicecontrols")}
          </Typography>

          {error && (
            <Alert severity='error' sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            variant='fullWidth'
            sx={{ mb: 6 }}
          >
            {showWaterValveControls && <Tab label={t("device.details_watervalvecontrol")} value='waterValve' />}
            <Tab label={t("device.details_alertsettings")} value='alertSettings' />
          </Tabs>

          <Grid container spacing={6}>
            {showWaterValveControls && activeTab === "waterValve" && (
              <Grid item xs={12}>
                <WaterValveControl device={device} />
              </Grid>
            )}

            {activeTab === "alertSettings" && (
              <Grid item xs={12}>
                <AlertSettings device={device} />
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DeviceControlComponent;
